import * as React from "react"

const SvgSection = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M3.986 18h16.039q.425 0 .7.288.275.287.275.712c0 .425-.096.52-.288.712a.96.96 0 0 1-.687.288H3.975a.93.93 0 0 1-.7-.288A1 1 0 0 1 3 19q0-.424.288-.712A.96.96 0 0 1 3.974 18h.01Zm1.017-4h13.994l.001-.002.002-.001v-3.993l-.002-.002-.001-.002H5.003l-.001.002-.002.002v3.993l.002.001zM3.986 4h16.039q.425 0 .7.288Q21 4.575 21 5c0 .425-.096.52-.288.713A.96.96 0 0 1 20 6H3.975a.93.93 0 0 1-.7-.287A1 1 0 0 1 3 5q0-.424.288-.712A.96.96 0 0 1 3.986 4m-.399 11.412Q4.176 16 5 16h14q.824 0 1.413-.588Q21 14.825 21 14v-4q0-.825-.587-1.412A1.93 1.93 0 0 0 19 8H5q-.824 0-1.413.588A1.93 1.93 0 0 0 3 10v4q0 .825.587 1.412"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgSection
